import { Cookie } from '@phosphor-icons/react';
import { Button } from 'src/v2/commonComponents/Button';
import { SVG_SIZE_M } from 'src/constants';
import styles from './CookieButton.module.scss';
import classNames from 'classnames';
import { useFeatureFlagEnabled } from 'posthog-js/react';

interface CookieButtonProps {
  variant?: 'fixed' | 'inline';
}

export const CookieButton = ({ variant = 'inline' }: CookieButtonProps) => {
  const isCookieButtonDialogEnabled =
    useFeatureFlagEnabled('cookieButtonDialog');

  const onClick = () => {
    if (typeof window !== 'undefined' && window.Osano) {
      window.Osano?.cm.showDrawer('osano-cm-dom-info-dialog-open');
    }
  };

  const isInline = variant === 'inline';

  if (!isCookieButtonDialogEnabled) {
    return null;
  }

  return (
    <Button
      className={classNames(styles.root, {
        [styles.fixed]: variant === 'fixed',
      })}
      onClick={onClick}
      color={isInline ? 'transparent' : 'secondary'}
      fullWidthWithLeftAlign={isInline}
      shape={isInline ? 'regular' : 'round'}
    >
      <Cookie size={SVG_SIZE_M} />
      {isInline && 'Cookie consent'}
    </Button>
  );
};
